/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftToArc = createReactComponent("arrow-left-to-arc", "IconArrowLeftToArc", [
  ["path", { d: "M21 12h-12", key: "svg-0" }],
  ["path", { d: "M13 16l-4 -4l4 -4", key: "svg-1" }],
  ["path", { d: "M12 3a9 9 0 1 0 0 18", key: "svg-2" }]
]);

export { IconArrowLeftToArc as default };
//# sourceMappingURL=IconArrowLeftToArc.js.map
